<label for="search_{{ unifyKey(key) }}">
  <input
    nbInput
    fieldSize="tiny"
    type="text"
    id="search_{{ unifyKey(key) }}"
    aria-label="Search"
    placeholder="{{ column.placeholder ? column.placeholder : column.title }}"
    #input
    (keyup)="onKey(input, $event)"
    (input)="onSearch(input)"
  />
</label>
